import React from "react";
import LoginStore from "./login/loginStore"
import { attach } from "./common/componentExtensions";
import { AccountData } from "./generated";
import DashBoard from "./dashboard/components/dashboard"


const Home: React.FunctionComponent<{ user: AccountData | null }> = ({ user }) => (
    <div>
        {user != null ? <DashBoard /> : <h2>Home</h2>}
    </div>
);

export default attach(Home, LoginStore, (store, props) => {
    return { user: store.get() }
})